<h1 mat-dialog-title class="edit-prg-title-box">

    <div class="outer-left-title-box">

        <div *ngIf="autoSaved" class="corner-icon-box">
            <img src="assets/icons/Auto_Saved.webp" alt="">
            <div class="save-action-tooltip">All changes saved.</div>
        </div>

        <div *ngIf="!autoSaved" class="corner-icon-box">
            <img src="assets/icons/Changes_Not_Saved.webp" alt="">
            <div class="save-action-tooltip not-saved-tooltip">Changes not saved.</div>
        </div>

        <div class="left-title-box">
            <div class="heading">
                <span>{{ programDataCopy.name }}</span>
                <div class="icon-box">
                    <div class="left-characters">{{65 - programDataCopy?.name?.length}} characters left</div>
                    <mat-icon class="action-icon">more_vert</mat-icon>
                    <div class="options-popup">
                        <div [ngStyle]="{'background': isPrgNameEditable ? 'gainsboro' : ''}" (click)="toggleEditPrgName('Program Name', programDataCopy.name, 65)">Edit Program Name</div>
                        <div [ngStyle]="{'background': isPrgTaglineEditable ? 'gainsboro' : ''}" (click)="toggleEditTagline('Program Tagline', programDataCopy.tagline, 80)">Edit Program Tagline</div>
                    </div>
                </div>
            </div>
            <div class="description">
                <span>{{ programDataCopy?.tagline || ''}}</span>
                <div class="left-characters">{{80 - programDataCopy?.tagline?.length}} characters left</div>
            </div>
        </div>
    </div>
    <div class="right-btns-box">
        <button class="extra-btn"></button>
        <button class="delete"  mat-button (click)="deleteItem('program', -1)">Delete</button>
        <button class="exit" mat-button mat-dialog-close (click)="closeEditProgramBuilder('cancel')">Exit</button>
        <button class="save" mat-button (click)="routeToPreview()">Preview</button>
        <button class="publish" mat-button (click)="publishProgram()">Publish</button>
    </div>
</h1>
<div mat-dialog-content>

    <div class="top-boxes-container">
        <div #descBoxRef class="first-outer-box">
            <div class="first-box">
                <div class="desc-heading">
                    <span>Program Description</span>
                    <!-- <mat-icon>more_vert</mat-icon> -->

                    <div class="icon-box">
                        <mat-icon class="action-icon">more_vert</mat-icon>
                        <div class="options-popup">
                            <div [ngStyle]="{'background': isDescriptionEditable ? 'gainsboro' : ''}" (click)="toggleEditDescription('Description', programDataCopy.description, 750)">Edit DESCRIPTION</div>
                            <!-- <div>.........</div>
                            <div>.........</div>
                            <div>Delete DESCRIPTION</div> -->
                        </div>
                    </div>
                </div>
                <div class="desc-text">
                    <textarea [maxlength]="750"
                    [(ngModel)]="programDataCopy.description"
                    name="description"
                    [readonly]="isDescriptionEditable ? false : true"
                    rows="1"
                    placeholder="Enter description..."
                  ></textarea>
                </div>
                <div class="left-characters">{{750 - programDataCopy.description.length}} characters left</div>
            </div>
        </div>

        <div class="right-top-boxes">
            <div class="second-box">
                <div class="image-heading">
                    <span>Program Images</span>
                    <!-- <mat-icon>more_vert</mat-icon> -->
                    <div class="icon-box" style="visibility: hidden;">
                        <mat-icon class="action-icon">more_vert</mat-icon>
                        <div class="options-popup">
                            <div>Edit</div>
                            <div>........</div>
                            <div>........</div>
                            <div>Delete .....</div>
                        </div>
                    </div>
                </div>
                <div class="upload-boxes">
                    <div class="square-box">
                        <div class="title-upld-box">
                            <div class="title">Square</div>
                            <div *ngIf="programDataCopy?.programImage" class="img-upld-box">
                                <!-- <input type="file" (change)="onFileChange($event, 'programImage')" accept=".png,.jpg" required /> -->
                                <mat-icon (click)="removeSquareImage()">close</mat-icon>
                                <!-- <img *ngIf="programDataCopy?.programImage" src="../../../../../../../assets/icons/Creation Centre Icons/Edit.png" alt=""> -->
                            </div>
                        </div>
                        <div class="upload-box" [ngClass]="{'upload-box-padding': !programDataCopy?.programImage}">
                            <ng-container *ngIf="!programDataCopy?.programImage">
                                <img src="../../../../../../../assets/icons/Creation Centre Icons/Upload.png" class="upload-icon" style="height: 38px;" alt="upload-icon">
                                <div class="drag-drop-text">(You can also drag & drop!)</div>
                            </ng-container>
                            

                            <!-- <mat-icon class="upload-icon" *ngIf="!programDataCopy?.programImage">upload</mat-icon> -->
                            <img *ngIf="programDataCopy?.programImage" (click)="previewImage(programDataCopy.programImage, 'portrait')" style="height: 100%;width: 100%;" [src]="programDataCopy.programImage" />

                            <input *ngIf="!programDataCopy?.programImage" type="file" (change)="onFileChange($event, 'programImage')" accept=".png,.jpg" required />

                            <!-- <div *ngIf="programDataCopy?.programImage" class="delete-icon">
                                <mat-icon (click)="removeSquareImage()">close</mat-icon>
                            </div> -->
                        </div>
                    </div>
                    <div class="landscape-box">
                        <div class="title-upld-box">
                            <div class="title">Landscape</div>
                            <div *ngIf="programDataCopy?.landscapeImage" class="img-upld-box">
                                <!-- <input type="file" (change)="onFileChange($event, 'landscapeImage')" accept=".png,.jpg" required /> -->
                                <mat-icon (click)="removeLandscapeImage()">close</mat-icon>
                                <!-- <img src="../../../../../../../assets/icons/Creation Centre Icons/Edit.png" alt=""> -->
                            </div>
                        </div>
                        <div class="upload-box" [ngClass]="{'upload-box-padding': !programDataCopy?.landscapeImage}">
                            <ng-container *ngIf="!programDataCopy?.landscapeImage">
                                <img src="../../../../../../../assets/icons/Creation Centre Icons/Upload.png" class="upload-icon" style="height: 38px" alt="upload-icon">
                                <div class="drag-drop-text">(You can also drag & drop!)</div>
                            </ng-container>

                            <!-- <mat-icon class="upload-icon" *ngIf="!programDataCopy?.landscapeImage">upload</mat-icon> -->
                            <img *ngIf="programDataCopy?.landscapeImage" (click)="previewImage(programDataCopy.landscapeImage, 'landscape')" style="height: 100%;width: 100%;" [src]="programDataCopy.landscapeImage" />

                            <input *ngIf="!programDataCopy?.landscapeImage" type="file" (change)="onFileChange($event, 'landscapeImage')" accept=".png,.jpg" required />

                            <!-- <div *ngIf="programDataCopy?.landscapeImage" class="delete-icon">
                                <mat-icon (click)="removeLandscapeImage()">close</mat-icon>
                            </div> -->
                        </div>
                    </div>
                </div>
                <p class="note-msg">PNG or JPEG Required for both. Max size 1mb</p>
            </div>
            <div class="thired-box">
                <!-- <div class="input-box">
                    <label for="category">Category</label>
                    <select [(ngModel)]="programDataCopy.category.id" (change)="changeCategory($event.target.value)">
                        <option *ngFor="let cat of categories" [value]="cat.id">{{cat.name}}</option>
                    </select>
                </div>

                <div class="input-box" *ngIf="subCategories.length || programDataCopy.subCategory.id">
                    <label for="subcategory">Sub Category</label>
                    <select [(ngModel)]="programDataCopy.subCategory.id" (change)="changeSubCategory($event.target.value)">
                        <option *ngFor="let subCat of subCategories" [value]="subCat.id">{{subCat.name}}</option>
                    </select>
                </div>                 -->

                <div class="input-box">
                    <mat-label>Category</mat-label>
                    <mat-select [(value)]="programDataCopy.category.id" (selectionChange)="changeCategory($event.value)">
                        <mat-option *ngFor="let cat of categories" [value]="cat.id">{{cat.name}}</mat-option>
                    </mat-select>
                </div>

                <div class="input-box" *ngIf="subCategories.length || programDataCopy.subCategory.id">
                    <mat-label>Sub Category</mat-label>
                    <mat-select [(value)]="programDataCopy.subCategory.id" (selectionChange)="changeSubCategory($event.value)">
                        <mat-option *ngFor="let subCat of subCategories" [value]="subCat.id">{{subCat.name}}</mat-option>
                    </mat-select>
                </div>

                <div class="input-box">
                    <mat-label>Difficulty</mat-label>
                    <mat-select [(ngModel)]="programDataCopy.difficultyLevel" (selectionChange)="changeDifficultyLevel()">
                        <mat-option value="easy">Easy</mat-option>
                        <mat-option value="medium">Medium</mat-option>
                        <mat-option value="hard">Hard</mat-option>
                    </mat-select>
                </div>
                <div class="input-box">
                    <label for="programTime">Program Time</label>
                    <input type="text" [(ngModel)]="programDataCopy.courseTime" (ngModelChange)="courseTimeEventCapture($event)" name="" value="" placeholder="hh:mm" maxlength="5">
                    <!-- <select>
                        <option value="00:01">00:01</option>
                        <option value="00:02">00:02</option>
                        <option value="00:03">00:03</option>
                    </select> -->
                </div>
                <div class="input-box showProgramToggle">
                    <label for="">Show Program</label>
                    <input id="" type="text" value="Display in Categories: " readonly>
                    <mat-slide-toggle [(ngModel)]="programDataCopy.isPublished" (change)="changeDisplayInCategories()"></mat-slide-toggle>
                </div>
            </div>
        </div>
    </div>

    <div class="table-headings">
        <div class="left-h-box">
            <div id="section-h">SECTION</div>
        </div>
        <div class="right-h-box">
            <div id="stack-h">STACK</div>
            <div id="dose-h">D.O.S.E</div>
            <div id="name-h">NAME</div>
            <div id="type-h">TYPE</div>
            <div id="point-h">POINTS</div>
            <div id="add-h">ADD</div>
            <div id="more-h">EDIT</div>
            <!-- <div id="add-icon">
				<mat-icon (click)="programItemDetailsCrud('add', 'section', 0)">add</mat-icon>
			</div> -->
        </div>
    </div>

    <div *ngIf="programDataCopy.sections && programDataCopy.sections.length; else noSections" class="content-box">
        <div cdkDropList class="section-list" (cdkDropListDropped)="dropSection($event)">
            <div *ngFor="let section of programDataCopy.sections; let sectionIndex = index" class="section-box" cdkDrag>
                <div [ngStyle]="{'height': descBoxHeight + 'px'}" class="left-box">
                    <div cdkDragHandle class="drag-handle-box">
                        <!-- <mat-icon>apps</mat-icon> -->
                        <mat-icon class="action-icon">more_vert</mat-icon>
                        <mat-icon class="action-icon">more_vert</mat-icon>
                        <mat-icon class="action-icon">more_vert</mat-icon>
                    </div>
                    <div class="content-box">
                        <div class="name">
                            <span>{{section.name}}</span>
                            <!-- <mat-icon>more_vert</mat-icon> -->

                            <div class="icon-box">
                                <mat-icon class="action-icon">more_vert</mat-icon>
                                <div class="options-popup">
                                    <div (click)="programItemDetailsCrud('edit', 'section', sectionIndex)">Edit SECTION</div>
                                    <div id="second_div" (click)="programItemDetailsCrud('add', 'section', sectionIndex)">Add SECTION above</div>
                                    <div id="thired_div" (click)="programItemDetailsCrud('add', 'section', sectionIndex + 1)">Add SECTION below</div>
                                    <div id="fourth_div" (click)="deleteItem('section', sectionIndex)">Delete SECTION</div>
									<div *ngIf="!section.menu || section.menu.length === 0" (click)="programItemDetailsCrud('add', 'unit', sectionIndex, 0)">Add UNIT</div>
                                </div>
                            </div>
                        </div>
                        <div class="desc">{{section.description}}</div>
						<!-- <div class="action-icon-box">
                            <mat-icon id="delete" (click)="deleteItem('section', sectionIndex)">delete</mat-icon>
                            <mat-icon id="edit" (click)="programItemDetailsCrud('edit', 'section', sectionIndex)">edit_square</mat-icon>
                        </div> -->
                        <div class="left-characters" style="margin-top: auto;padding-top: 5px;">{{300 - section.description.length}} characters left</div>
                    </div>
                </div>
                <div class="right-box">
                    <div cdkDropList class="unit-list" [cdkDropListData]="section.menu" (cdkDropListDropped)="dropUnit($event, sectionIndex)">
                        <div *ngFor="let unit of section.menu; let unitIndex = index" class="unit-box" cdkDrag>
                            <div class="unit-row">
                                <div class="stack">
                                    <!-- <mat-icon cdkDragHandle>apps</mat-icon> -->
                                    <mat-icon class="action-icon">more_vert</mat-icon>
                                    <mat-icon class="action-icon">more_vert</mat-icon>
                                    <mat-icon class="action-icon">more_vert</mat-icon>
                                </div>
                                <div class="dose">{{ unit.dfs }}</div>
                                <div class="desc">{{unit.name}}</div>

                                <ng-container *ngIf="unit.type; else typeEmpty">
                                    <div class="type" *ngIf="unit.type === 'video' || unit.type === 'Video'">
                                        <!-- <mat-icon>videocam</mat-icon> -->
                                        <img src="../../../../../../../assets/icons/Creation Centre Icons/Video.png" style="height: 30px;" alt="">
                                    </div>
                                    <div class="type" *ngIf="unit.type === 'quiz' || unit.type === 'Quiz'">
                                        <!-- <mat-icon>task</mat-icon> -->
                                        <img src="../../../../../../../assets/icons/Creation Centre Icons/Quiz.png" style="height: 30px;" alt="">
                                    </div>
                                    <div class="type" *ngIf="unit.type === 'download' || unit.type === 'Download'">
                                        <!-- <mat-icon>download</mat-icon> -->
                                        <img src="../../../../../../../assets/icons/Creation Centre Icons/Download.png" style="height: 30px;" alt="">
                                    </div>
                                </ng-container>

                                <ng-template #typeEmpty>
                                    <div class="type"> - </div>
                                </ng-template>


                                <div class="point">{{unit.pts}}</div>
                                <div class="add">
                                    <!-- <mat-icon>add_circle</mat-icon> -->
                                    <div class="add-inner">
                                        <img src="../../../../../../../assets/icons/Creation Centre Icons/Add.png" style="height: 25px;" alt="">
                                        <div class="options-popup">
                                            <!-- <div (click)="programItemDetailsCrud('edit', 'unit', sectionIndex, unitIndex)">Edit UNIT</div> -->
                                            <div (click)="programItemDetailsCrud('add', 'unit', sectionIndex, unitIndex)">ADD Unit Above</div>
                                            <div (click)="programItemDetailsCrud('add', 'unit', sectionIndex, unitIndex + 1)">ADD Unit Below</div>
                                            <!-- <div (click)="deleteItem('unit', sectionIndex, unitIndex)">Delete UNIT</div> -->
                                        </div>
                                    </div>
                                </div>
                                <div class="more">
                                    <div class="more-inner">
                                        <mat-icon class="action-icon" style="height: 25px;">more_vert</mat-icon>
                                        <div class="options-popup">
                                            <div (click)="programItemDetailsCrud('edit', 'unit', sectionIndex, unitIndex)">EDIT Unit</div>
                                            <!-- <div (click)="programItemDetailsCrud('add', 'unit', sectionIndex, unitIndex)">Add UNIT above</div>
                                            <div (click)="programItemDetailsCrud('add', 'unit', sectionIndex, unitIndex + 1)">Add UNIT below</div> -->
                                            <div (click)="deleteItem('unit', sectionIndex, unitIndex)">DELETE Unit</div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="action-btn">
                                    <mat-icon id="delete" (click)="deleteItem('unit', sectionIndex, unitIndex)">delete</mat-icon>
                                    <mat-icon id="edit" (click)="programItemDetailsCrud('edit', 'unit', sectionIndex, unitIndex)">edit_square</mat-icon>
                                </div> -->
                            </div>
                            <!-- <div id="lastElem" *ngIf="unitIndex === section.menu.length - 1; else notLastElement">
                                <mat-icon (click)="programItemDetailsCrud('add', '', sectionIndex, unitIndex)">add</mat-icon>
                            </div>
                            <ng-template #notLastElement>
                                <div id="add-icon">
                                    <mat-icon (click)="programItemDetailsCrud('add', 'unit', sectionIndex, unitIndex)">add</mat-icon>
                                </div>
                            </ng-template> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <ng-template #noSections>
        <div class="get-started-btn">
            <button mat-button (click)="programItemDetailsCrud('add', 'section', 0)">ADD A SECTION</button>
        </div>
    </ng-template>


</div>

<!-- <div mat-dialog-actions style="display: flex;justify-content: flex-end;">
    <button mat-button cdkFocusInitial (click)="deleteItem('program', -1)">Delete</button>
    <button mat-button mat-dialog-close (click)="closeEditProgramBuilder('cancel')">Cancel</button>
    <button mat-button cdkFocusInitial (click)="closeEditProgramBuilder('save')">Save</button>
</div> -->